// extracted by mini-css-extract-plugin
export default {"ShareEvent":"ShareEvent_ShareEvent__tnOo-","shad":"ShareEvent_shad__oc6O-"};